import React from 'react';
import store from '../store';
import FloatButton from '../components/FloatButton';
//import CardContent from '../components/CardContent';
import Toolbar from '../components/Toolbar';
import DialogCourse from '../components/DialogCourse';
import DialogExport from '../components/DialogExport';
import CardCourse from '../components/CardCourse';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import  FormControl  from '@material-ui/core/FormControl';
import Button  from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import Grid from '@material-ui/core/Grid';
import GroupWorkIcon from '@material-ui/icons/Group';
import ReceiptIcon from '@material-ui/icons/Receipt';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import { FIREBASE } from "../config/firebase";
import Divider from '@material-ui/core/Divider';
import { Redirect } from 'react-router-dom';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import AddIcon from '@material-ui/icons/Add';
const DWIDTH = 640;
if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE);
}
const styles = theme => ({
    title: {
        marginBottom: theme.spacing.unit * 2,
        padding: 0
    },
    search: {
        backgroundColor: '#fff',
        padding: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 2,
        borderRight: 'solid 1px #ededed',
        borderLeft: 'solid 1px #ededed',
        borderTop: 'solid 1px #ededed'
    },
    buttonAdd: {
        margin: theme.spacing.unit,
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
});

function a(q, f) {
    try {
        if (q.toLowerCase().includes(f)) {
            return true;
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
}


class AdminCourse extends React.Component {
    constructor() {
        super();
        this.state = { search: '',contents:[],open:false,openPractice:false};

    }
    loadContents(){
      console.log('load Contents');
      let _this = this;
      let sub = firebase.firestore().collection('courses').orderBy('created','desc').onSnapshot((data)=>{
        let contents = [];
        data.forEach((doc)=>{
          let item = doc.data();
          item.id=doc.id;
          contents.push(item);
        })

        _this.setState({contents});
      })
      _this.setState({sub});
    }
    loadDataCoures(){
      console.log('load Data Courses');
      let _this = this;
      firebase.firestore().collection('data_courses').where("enable","==",1).orderBy('ten').get().then((data)=>{
        let DATA_COURSES = [];
        data.forEach((doc)=>{
          let item = doc.data();
          //item.id=doc.id;
          DATA_COURSES.push(item);
        })

        _this.setState({DATA_COURSES});
        store.dispatch({ type: 'DATA_COURSES', DATA_COURSES });
      })

    }
    componentDidMount(){
      this.loadContents();
      this.loadDataCoures();
    }
    componentWillUnmount(){
      if(this.state.sub)
      this.state.sub();
    }
    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };
    handleClose = value => {
        this.setState({ open: false });
    };
    handleClosePractice = value => {
        this.setState({ openPractice: false });
    };
    handleClickOpen = () => {
            this.setState({
                open: true,
            });
        };
        handleClickOpenPractice= () => {
                this.setState({
                    openPractice: true,
                });
            };



    render() {
        const { classes } = this.props;
        const { search,contents } = this.state;

        const item_button =  { name:"", startDate: '',endDate:'',week:4,course_id:0,created:(new Date()).getTime() };
        if(!store.getState().ADMINACCOUNT)
        {
          console.log('No Admin');
          return <Redirect to='/sbadmin' />
        }
        return (
          <div>
          <Toolbar/>
            <div style={{ maxWidth: '720px',margin: '20px auto',paddingTop: '64px'}}>
                <Grid justify="flex-start" direction="row" container>
                    <Grid item><AllInboxIcon style={{ marginRight: 10 }} /></Grid>
                    <Grid item><Typography variant="title" className={classes.title}>Course</Typography></Grid>
                </Grid>
                <FormControl style={{ marginBottom: 30 }} fullWidth>
                    <Input
                        value={this.state.search}
                        onChange={this.handleChange('search')}
                        type="text"
                        placeholder="Search a course"
                        className={classes.search}
                    />
                </FormControl>
                <Button onClick={this.handleClickOpenPractice} variant="contained" color="secondary" aria-label="add">
                    Export Practice
                </Button>
                {this.state.contents.filter(i => {
                    let f = search.toLowerCase();
                    return a(i.name,f) ;
                }).map((item, index) => {
                    return <CardCourse item={item} key={index} />
                })}
                <div style={{ height: 100, display: 'block' }} />

                </div>
                <div>
                                {this.state.open ? '' :
                                    <Button onClick={this.handleClickOpen} variant="fab" color="secondary" aria-label="add" className={classes.buttonAdd}>
                                        <AddIcon />
                                    </Button>}
                                {this.state.open ?<DialogCourse
                                    item={item_button}
                                    fullScreen={true}
                                    open={this.state.open}
                                    onClose={this.handleClose}
                                />:false}
                                {this.state.openPractice ?<DialogExport
                                    item={item_button}
                                    fullScreen={true}
                                    open={this.state.openPractice}
                                    onClose={this.handleClosePractice}
                                />:false}
                            </div>
            </div>
        )
    }
}

AdminCourse.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminCourse);
